import Substance from './Substance';
import { CATEGORY_LABELS, SUBSTANCE_CATEGORIES } from '../constants/effects';
import { getPeriodicTablePosition } from '../utils/periodicTableUtils';

// Elements after uranium are made by scientists and don't exist in nature in useful amounts.
const LAST_NATURAL_ATOMIC_NUMBER = 92;

/**
 * A single element from the periodic table.
 */
export default class Element extends Substance {
  constructor({ atomicNumber, atomicMass, description, ...rest }) {
    super({ id: rest.symbol, ...rest });
    this.atomicNumber = atomicNumber;
    this.atomicMass = atomicMass;
    this.tablePosition = getPeriodicTablePosition(atomicNumber);
    this.description = description || this.createDefaultDescription();
  }

  isElement() {
    return true;
  }

  isNobleGas() {
    return this.category === SUBSTANCE_CATEGORIES.NOBLE_GAS;
  }

  isSynthetic() {
    return this.atomicNumber > LAST_NATURAL_ATOMIC_NUMBER;
  }

  isMetal() {
    return [
      SUBSTANCE_CATEGORIES.ALKALI_METAL,
      SUBSTANCE_CATEGORIES.ALKALINE_EARTH_METAL,
      SUBSTANCE_CATEGORIES.TRANSITION_METAL,
      SUBSTANCE_CATEGORIES.POST_TRANSITION_METAL,
      SUBSTANCE_CATEGORIES.LANTHANIDE,
      SUBSTANCE_CATEGORIES.ACTINIDE,
    ].includes(this.category);
  }

  createDefaultDescription() {
    const familyName = CATEGORY_LABELS[this.category].toLowerCase();
    const origin = this.isSynthetic() ? ' It is made by scientists in special labs.' : '';
    return `Element number ${this.atomicNumber}, from the ${familyName} family.${origin}`;
  }
}
